<h5 class="header">Primary</h5>

<div class="colorpicker-wrapper">
  <input class="colorpicker" [(ngModel)]="color.primary" />
  <div class="color-visualizer" [(colorPicker)]="color.primary" [style.background]="color.primary" cpOutputFormat="hex"></div>
</div>

<h5 class="header">Secondary</h5>

<div class="colorpicker-wrapper">
  <input class="colorpicker" [(ngModel)]="color.secondary" />
  <div class="color-visualizer" [(colorPicker)]="color.secondary" [style.background]="color.secondary" cpOutputFormat="hex"></div>
</div>

<h5 class="header">Tertiary</h5>

<div class="colorpicker-wrapper">
  <input class="colorpicker" [(ngModel)]="color.tertiary" />
  <div class="color-visualizer" [(colorPicker)]="color.tertiary" [style.background]="color.tertiary" cpOutputFormat="hex"></div>
</div>

<h5 class="header">Accent</h5>

<div class="colorpicker-wrapper">
  <input class="colorpicker" [(ngModel)]="color.accent" />
  <div class="color-visualizer" [(colorPicker)]="color.accent" [style.background]="color.accent" cpOutputFormat="hex"></div>
</div>

<button class="btn btn-outline-primary" (click)="updateCss()">Save colors</button>
